/*eslint-disable*/
export default header => {
  let over = false
  let body = document.querySelector('body')
  //  FIXME: Add this logic to if statment below if Linen KLP should have transparent nav, and solid on scroll
  //  -->   || $(body).attr('id') === "linen"
  // $( document ).ready(function() {
  //   if($(body).attr('id') === 'lookbook'){
  //     header.classList.remove('is-scrolled')
  //   }
  // });
  if (body.classList.contains('template-index') || $(body).attr('id') === 'holiday-gift-guide' || $(body).attr('id') === 'valentines-day-gift-guide' || $(body).attr('id') === 'hosting-lookbook') {
    window.addEventListener('scroll', e => {
      if (window.scrollY > 1 && !over && $(body).attr('id') != 'hosting-lookbook') {
        over = true
        header.classList.add('is-scrolled')
      } else if (window.scrollY < 1 && over || $(body).attr('id') === 'hosting-lookbook') {
        over = false
        header.classList.remove('is-scrolled')
      }
    })

  }
  if (body.id === 'valentines-day-gift-guide') {
    $("header")[0].classList.add('header__valentines')
  } else if (body.id === 'holiday-gift-guide-20') {
    $("header")[0].classList.add('header__hgg')
  }


  // const cartToggle = header.querySelector('.js-cart-drawer-toggle')
  const searchOpeners = header.querySelectorAll('.js-open-search')
  const searchClose = header.querySelector('.js-close-search')
  const search = header.querySelector('.js-search')

  // audit the old cart
  // cartToggle.addEventListener('click', () => {
  //   const cartDrawer = scripts.cache.get('cart-drawer')
  //   cartDrawer.open()
  // })

  searchOpeners.forEach(searchOpen => {(
    searchOpen.addEventListener('click', () => {
      header.querySelector('.header__search').classList.add('search-open')
      header.classList.add('is-search-open')
      $('#header').css('z-index', 99999999)
      setTimeout(() => {
        search.focus()
        search.select()
      }, 500)
    })
  )})

  searchClose.addEventListener('click', () => {
   clear()
  })

  const clear = () => {
    $('#header').css('z-index', 500)
    header.querySelector('.header__search').classList.remove('search-open')
    header.classList.remove('is-search-open')
    $(search).val("")
    search.blur()
  }

  $(document).keydown(e => {e.keyCode === 27 && clear()})
  $(document).click((e)=>{
    if(matchMedia("(min-width:768px)").matches) {
    !$(e.target).closest('.snize-ac-results').length 
    && !$(e.target).hasClass('.snize-ac-results').length 
    && !$(e.target).closest('.js-open-search').length 
    && !$(e.target).closest('.header__search').length 
    && !$(e.target).hasClass('.js-open-search').length 
    && clear()
    }
  })

  // Mobile Navigation
  const mobileToggle = header.querySelector('.js-mobile-nav-toggle')
  const mobileNav = header.querySelector('.js-mobile-nav')
  mobileToggle.addEventListener('click', () => {
    header.classList.toggle('is-mobile-open')
    mobileToggle.classList.toggle('open')
    mobileNav.classList.toggle('open')
  })

  const mobileMoreNavs = header.querySelectorAll('.js-mobile-nav-more')
  const mobileNavCollectionContainer = header.querySelectorAll('.js-collection-container')
  const mobileNavSubcollectionLink = header.querySelectorAll('.subcollection-link')
  mobileNavSubcollectionLink.forEach(subcollectionLink => subcollectionLink.addEventListener('click', e=> e.stopPropagation()))
  mobileMoreNavs.forEach(mobileNav => {
    const parentLinks = mobileNav.querySelectorAll('a.parent-link')
    parentLinks.forEach(parentLink => {
      parentLink.addEventListener('click', e => {
        e.stopPropagation()
        $(mobileNav).hasClass('open') && $(mobileNav).find('.js-collection-container').each((idx, collectionContainer) => {
          $(collectionContainer).removeClass('open')
        })
        mobileNav.classList.toggle('open')
        !mobileNav.classList.contains('open') && $(mobileNav).find('.header__mobile_nav_more').css('max-height', '')
      })
    })
    mobileNav.addEventListener('click', e => {
      mobileNav.classList.toggle('open')
      !mobileNav.classList.contains('open') && $(mobileNav).find('.header__mobile_nav_more').css('max-height', '')
      e.preventDefault()
    })
  })

  mobileNavCollectionContainer.forEach(mobileCollection => {
    const collectionLink = mobileCollection.querySelector('a.collection-link')
    collectionLink && collectionLink.addEventListener('click', e => {
      e.stopPropagation()
      $('.js-collection-container').each((_,sibling) => {
        sibling != mobileCollection && $(sibling).removeClass('open')
      })
      mobileCollection.classList.toggle('open')
      if(mobileCollection.classList.contains('open')) {
        $(mobileCollection).closest('.header__mobile_link.open').find('.header__mobile_nav_more').css('max-height', '800px')
        let childNumber = $('.header__mobile_link_collection').index(mobileCollection);
        $('.header__mobile_nav').animate({
          scrollTop: (childNumber * 45  ) + 45 
        }, 300)  
      }
      else {
        $(mobileCollection).closest('.header__mobile_link.open').find('.header__mobile_nav_more').css('max-height', '280px')
      }   
    })
  })
}


// WEBPACK FOOTER //
// ./src/scripts/components/header.js